module.exports = __webpack_public_path__ + "static/media/add.40a8db6a.svg";